// extracted by mini-css-extract-plugin
export default {"heading":"Filters_heading__ZKGzt","text":"Filters_text__66cwS","row":"Filters_row__6PA93"};